import { Box, styled } from "@mui/material";

export const SearchContainer = styled(Box)(({ theme }) => ({
  width: 374,
}));
